import { useEffect, useRef, useState } from "react";
import ToggleSwitch from "../../../components/toggle/ToggleSwitch";

export const PieceCrop = ({ piece, src, margin=0.2 }) => {
  const containerRef = useRef(null);
  const [size, setSize] = useState(0);
  const [showAlcoves, setShowAlcoves] = useState(true);

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect;
      setSize(Math.min(width, height) * 0.8);
    });

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  console.log(size);

  const { x1, y1, x2, y2 } = piece;
  const cropW = x2 - x1;
  const cropH = y2 - y1;

  const scale = size / Math.max(cropW * (1 + margin), cropH * (1 + margin));

  const cx = (x1 + x2) / 2;
  const cy = (y1 + y2) / 2;

  return (
    <div ref={containerRef} className="absolute top-0 left-0 bottom-0 right-0">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-lg overflow-hidden"
        style={{ width: size, height: size }}>
        <img
          src={src}
          alt=""
          className="absolute block max-w-none"
          style={{
            transformOrigin: "top left",
            transform: `
              scale(${scale})
              translate(${size / 2 / scale - cx}px, ${size / 2 / scale - cy}px)
            `,
          }}
        />

        {
          piece.alcoves.map((alcove, index) => {
            const deltaX = cropH > cropW ? (cropH - cropW) / 2 : 0;
            const deltaY = cropH < cropW ? (cropW - cropH) / 2 : 0;
            const posX = (alcove.x + deltaX) * scale;
            const posY = (alcove.y + deltaY) * scale;
            const radius = alcove.r * scale * 1.8;
            const opacity = showAlcoves ? 'opacity-60' : 'opacity-0';

            const isOk = alcove.score > 0.4;
            const color = isOk ? 'bg-green-500' : 'bg-red-500';

            return (
              <div key={index} className={`absolute ${color} ${opacity} transition -translate-y-1/2 -translate-x-1/2 rounded-full`}
                   style={{ top: `${posY}px`, left: `${posX}px`, width: `${radius}px`, height: `${radius}px` }}/>
            );
          })
        }

        <div className="absolute text-white text-lg font-semibold flex items-center gap-2 right-4 bottom-4 z-50" onClick={(e) => e.stopPropagation()}>
          Détails
          <ToggleSwitch enabled={showAlcoves} setEnabled={setShowAlcoves}/>
        </div>
      </div>
    </div>
  );
};
